import { render, staticRenderFns } from "./BackgroundColorBoxTool.vue?vue&type=template&id=9d9aa10c&"
import script from "./BackgroundColorBoxTool.vue?vue&type=script&lang=js&"
export * from "./BackgroundColorBoxTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports